/**
 * Personal action-inbox item for the `myTasks` dashboard widget — the
 * AI-ranked personal inbox. Distinct from a project's `ProjectAction`
 * (a project sub-entity). `id` is added here (the oracle renders a hardcoded
 * array by index) for a stable React key + mock identity.
 */
export const TASK_BUCKETS = ["today", "later"];
//# sourceMappingURL=task.js.map